((Orgy, $) => {
  'use strict';

  const breakpoint = 991;

  let girlsSum = 0;
  let $mainNavDesktop;
  let $addedSleeves;
  let $topBanner;
  let $hero;
  let originalOffset;
  let isMobile = 0;
  let collectionHandle

  const cacheDom = () => {
    $mainNavDesktop = $('.main-navigation');
    $addedSleeves = $('.added-sleeves');
    $hero = $('.hero');
    $topBanner = $('.top-banner');
  };

  const setVariables = (options) => {
    collectionHandle = options.collectionHandle;
  };

  const goToStar = () => {
    const urlSearch = window.location.search;
    const searchArr = urlSearch.slice(1, urlSearch.length).split('&');
    const searchObj = {};

    for (let i = 0; i < searchArr.length; i++) {
      let current = searchArr[i].split('=')
      searchObj[current[0]] = current[1];
    }

    if (searchObj.star) {
      let top = $(`#${searchObj.star}`).offset().top - 300;

      if ($(window).width() < 992) {
        top += 200;
      }

      $('html, body').animate({
        scrollTop: top
      }, 2000);
    }
  };

  const getOffsets = () => {
    originalOffset = $addedSleeves.offset().top;
  };

  const addOrgyPrice = (currentSleevePrice) => {
    const currentOrgyPrice = Number($('.orgy-price').text());
    const updatedOrgyPrice = parseFloat(currentOrgyPrice + currentSleevePrice).toFixed(2);
    $('.orgy-price').text(updatedOrgyPrice);

    girlsSum++;
    $('.girls-sum').text(girlsSum);

    if (girlsSum == 1) {
      $('.orgy-girls').addClass('girls-active');
      $('.orgy-total').css('display', 'flex');
      $('.mobile-add-to-cart').show();
    }
  };

  const subtractOrgyPrice = (currentSleevePrice) => {
    const currentOrgyPrice = Number($('.orgy-price').text());
    const updatedOrgyPrice = parseFloat(currentOrgyPrice - currentSleevePrice).toFixed(2);
    $('.orgy-price').text(updatedOrgyPrice);

    girlsSum--;
    $('.girls-sum').text(girlsSum);

    if (girlsSum == 0) {
      $('.orgy-girls').removeClass('girls-active open');
      $('.orgy-total').hide();
      if ($(window).width() <= 992) {
        $('.orgy-list, .mobile-add-to-cart').hide();
      }
    }
  };

  const selectSleeve = (selectedSleeve) => {
    $(selectedSleeve).addClass('orgy-sleeve-selected');
    $(selectedSleeve).clone().prependTo('.added-sleeves ul');
  };

  const deselectSleeve = (selectedSleeve) => {
    const variantId = $(selectedSleeve).attr('data-orgy-sleeve-id');

    $(selectedSleeve).removeClass('orgy-sleeve-selected');
    $('.added-sleeves ul').find('li[data-orgy-sleeve-id="' + variantId + '"]').remove();
  };

  const multiBinds = () => {
    $(window).on('load resize', function () {
      const width = $(window).width();

      if ((width <= breakpoint) && (isMobile === 0)) {
        $('.added-sleeves').insertAfter('.products');
        isMobile = 1;
      } else {
        if (width > breakpoint && (isMobile === 1)) {
          isMobile = 0;
          $('.added-sleeves').insertAfter('.hero');
        }
      }
    });
  };

  const scrollBinds = () => {
    $(window).on('scroll', function () {
      if ($(this).width() > 991) {
        let top = $(this).scrollTop();
        let mainNavHeightDesktop = $mainNavDesktop.height();

        if ($topBanner.length > 0) {
          mainNavHeightDesktop += $topBanner.outerHeight();
          top += $topBanner.outerHeight();
        }

        if (top >= originalOffset - ($addedSleeves.height() / 2)) {
          $addedSleeves.css({
            position: 'fixed',
            bottom: 'inherit',
            top: mainNavHeightDesktop,
            zIndex: 10
          });
        } else {
          $addedSleeves.css({
            position: 'static',
            bottom: 0,
            top: 'inherit',
            zIndex: 10
          });
        }
      }
    });
  };

  const clickBinds = () => {
    $('.orgy-sleeve-table li').on('click', function () {
      const $this = $(this);
      const sleevePrice = Number(parseFloat($this.attr('data-orgy-sleeve-price')).toFixed(2));

      if ($this.hasClass('orgy-sleeve-selected')) {
        deselectSleeve($this);
        subtractOrgyPrice(sleevePrice);
      } else {
        selectSleeve($this);
        addOrgyPrice(sleevePrice);
      }
    });

    $(document).on('click', '.close-sleeve', function (e) {
      e.preventDefault();
      $(this).parent().remove();
      var selectedVariant = $(this).parent().attr('data-orgy-sleeve-id');
      $('li[data-orgy-sleeve-id="' + selectedVariant + '"]').removeClass('orgy-sleeve-selected');

      subtractOrgyPrice($(this).parent().attr('data-orgy-sleeve-price'));
    });

    $('.orgy-girls').on('click', function () {
      if (girlsSum > 0) {
        $(this).toggleClass('open');
        $('.orgy-list').slideToggle();
      }
    });

    $('.add-to-cart').on('click', function () {
      const $this = $(this);

      let variant_array = [];

      $('.orgy-list li').each(function () {
        variant_array.push($(this).attr('data-orgy-sleeve-id'));
      });

      $(this).text('ADDING');
      variant_array.forEach(function (id) {
        CartJS.addItem(id, 1, {
          orgy_product: 'true'
        });
      });

      $(document).on('cart.requestComplete', function (event, cart) {
        $('.add-to-cart').text('ADD TO CART');
        variant_array = [];
      });

      if (window.Cookies.get('BVAUpsell')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else {
        const title = $this.attr('data-product-upsell-title');
        const $upsellTitle = $('.js-product-upsell-title');

        if (title) {
          $upsellTitle.text(title);
        } else {
          $upsellTitle.text(window.ProductUpsell.defaultTitle);
        }
        ProductUpsell.open(collectionHandle);
      }
    });
  };

  const bindUIActions = (country) => {
    if (typeof country === 'undefined') {
      clickBinds();
    }
    scrollBinds();
    multiBinds();
  };

  const init = (options) => {
    cacheDom();
    setVariables(options);
    goToStar();
    getOffsets();
    bindUIActions(options.country);
  };

  Orgy.init = init;
  Orgy.clickBinds = clickBinds;
})(window.Orgy = window.Orgy || {}, jQuery);
